import { rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';

/** 採番方法区分のENUM */
enum NumberingMethodClass {
  enterDirectly = '1',
  automaticNumbering = '2',
  notChange = '3',
}

const numberingMethodClassMap = new Map([
  ['1', NumberingMethodClass.enterDirectly],
  ['2', NumberingMethodClass.automaticNumbering],
  ['3', NumberingMethodClass.notChange],
]);

function rawValueToNumberingMethodClass(rawValue: string) {
  return rawValueToEnumWithDefault(numberingMethodClassMap, NumberingMethodClass.notChange)(rawValue);
}

export { NumberingMethodClass, rawValueToNumberingMethodClass };
